import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "It looks like we're unable to deliver the code to your email", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Please reach out to our support center, and we’ll assist you with a solution ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" We've sent a verification code to your email. If you don’t see it, please check your "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "spam folder")
], -1)
const _hoisted_9 = { class: "number-code" }
const _hoisted_10 = {
  key: 0,
  class: "error-text"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "btn-group-main" }
const _hoisted_13 = ["disabled"]

import { ref, Ref, watch } from "vue";
import { defineEmits } from "vue/dist/vue";
import { User, useUserStore } from "@/stores/user";
import MainLoader from "@/components/MainLoader.vue";
import { ErrorType } from "@/query";
import VOtpInput from "vue3-otp-input";
import router from "@/router";
import { useAppStore } from "@/stores/app";
import { requestedCountriesFromUrl } from "@/helpers";
import { Country, useDataStore } from "@/stores/data";
import WhatsappIcon from "@/components/icons/WhatsappIcon.vue";

const codeTimerCooldown = 15;


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthCode',
  emits: ["back"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const goBack = () => emit("back");

const userStore = useUserStore();
const dataStore = useDataStore();
const appStore = useAppStore();

const codeConfirmLoading: Ref<boolean> = ref(false);
const codeInvalid: Ref<boolean> = ref(false);
const resentCodeTime: Ref<number> = ref(codeTimerCooldown);
const resentCodeTimer: Ref<number> = ref(0);
const resentCodeLoading: Ref<boolean> = ref(false);
const sendMailAttemptNumber: Ref<boolean> = ref(2);
const showError: Ref<boolean> = ref(false);

const otpInput = ref<InstanceType<typeof VOtpInput> | null>(null);
const code: Ref<string> = ref("");

function decrementCodeTime(): void {
  if (resentCodeTime.value <= 0) {
    stopCodeTimer();
  } else {
    resentCodeTime.value--;
  }
}

const stopCodeTimer = (): void => clearTimeout(resentCodeTimer.value);

function startCodeTimer(): void {
  stopCodeTimer();
  resentCodeTime.value = codeTimerCooldown;
  resentCodeTimer.value = setInterval(decrementCodeTime, 1000);
}

startCodeTimer();

async function resentCode(): Promise<void> {
  resentCodeLoading.value = true;

  if (sendMailAttemptNumber.value > dataStore.maxSendMailAttemptNumber) {
    showError.value = true;
    return;
  } else {
    await userStore.login(sendMailAttemptNumber.value);
  }
  sendMailAttemptNumber.value = sendMailAttemptNumber.value + 1;

  stopCodeTimer();
  startCodeTimer();
  resentCodeLoading.value = false;
}

async function confirm(): Promise<void> {
  codeConfirmLoading.value = true;
  const response: User | ErrorType | null = await userStore.validate(
    code.value
  );
  if (response in ErrorType && ErrorType[response] === ErrorType.codeInvalid) {
    codeInvalid.value = true;
  } else {
    try {
      const bundleId = router.currentRoute.value.query.bundleId;
      const esimId = router.currentRoute.value.query.esimId;

      if (typeof bundleId === "string" && bundleId !== "null") {
        await router.push(
          `/bundle/${bundleId}?requestedCountries=${JSON.stringify(
            requestedCountriesFromUrl().map((c: Country) => c.iso)
          )}`
        );
      } else if (typeof esimId === "string" && esimId !== "null") {
        await router.push(`/esim/${esimId}`);
      } else {
        await router.push("/profile");
      }
    } catch (e) {
      await router.push("/profile");
    }
    appStore.closePopup();
  }
  codeConfirmLoading.value = false;
}

watch(code, () => (codeInvalid.value = false));

return (_ctx: any,_cache: any) => {
  return (showError.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("button", {
          onClick: goBack,
          class: "btn btn-b btn-danger d-block",
          type: "submit"
        }, " Try another email "),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        (_unref(dataStore).whatsappLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "whatsapp-button",
              href: _unref(dataStore).whatsappLink,
              target: "_blank"
            }, [
              _createVNode(WhatsappIcon, { class: "whatsapp-button__icon" }),
              _createTextVNode(" Chat on WhatsApp ")
            ], 8, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("form", {
        key: 1,
        onSubmit: _withModifiers(confirm, ["prevent"])
      }, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_unref(VOtpInput), {
            ref_key: "otpInput",
            ref: otpInput,
            "input-classes": "otp-input",
            conditionalClass: ['one', 'two', 'three', 'four'],
            separator: "",
            inputType: "numeric",
            "num-inputs": 4,
            value: code.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
            "should-auto-focus": true,
            "should-focus-order": true
          }, null, 8, ["value"])
        ]),
        (codeInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Invalid Code. Please try again"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-b btn-danger d-block",
          type: "submit",
          disabled: code.value.length < 4 || codeConfirmLoading.value || codeInvalid.value
        }, [
          _createTextVNode(" Confirm "),
          (codeConfirmLoading.value)
            ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_11),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-b btn-danger btn-back",
            onClick: goBack
          }, " Back "),
          _createElementVNode("button", {
            class: "timer",
            onClick: resentCode,
            disabled: resentCodeTime.value > 0 || resentCodeLoading.value
          }, [
            _createTextVNode(_toDisplayString(resentCodeTime.value > 0
            ? `00:${
                resentCodeTime.value < 10 ? `0${resentCodeTime.value}` : resentCodeTime.value
              }`
            : "Resent") + " ", 1),
            (resentCodeLoading.value)
              ? (_openBlock(), _createBlock(MainLoader, {
                  key: 0,
                  primary: ""
                }))
              : _createCommentVNode("", true)
          ], 8, _hoisted_13)
        ])
      ], 32))
}
}

})